import {connect} from 'react-redux';
import TabSurveyAssets from './TabSurveyAssets';
import {showLittlePopup} from '../../actions/step9LittlePopup';
import {saveSurveyAssetsRow} from '../../actions/steps/step9SaveRow';
import {saveTab4Values} from '../../actions/step9SaveTabFilters';

const mapStateToProps = ({
                          step9Filters: {tab4}
                        }) => ({
  previousValues: tab4,
});

export default connect(
  mapStateToProps,
  {
    showLittlePopup,
    saveRow: saveSurveyAssetsRow,
    saveValues: saveTab4Values,
  }
)(TabSurveyAssets);
